import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';

import { email as userEmailSelector } from '@Containers/Header/HeaderComponentSelectors';

import { remoteAccessDialogReducerKey } from './RemoteAccessDialogConstants';
import { step as stepSelector, departments as departmentsSelector, isLoading as isLoadingSelector } from './RemoteAccessDialogSelectors';
import {
  fetchDepartments as fetchDepartmentsAction,
  onDepartmentSelect as onDepartmentSelectAction,
  onActivationConfirm as onActivationConfirmAction,
} from './RemoteAccessDialogActions';
import remoteAccessDialogReducer from './RemoteAccessDialogReducer';
import RemoteAccessDialog from './RemoteAccessDialog';

const mapStateToProps = (state) => ({
  step: stepSelector(state),
  email: userEmailSelector(state),
  departments: departmentsSelector(state),
  isLoading: isLoadingSelector(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchDepartments: (email) => dispatch(fetchDepartmentsAction(email)),
  onDepartmentSelect: (department, email) => dispatch(onDepartmentSelectAction(department, email)),
  onActivationConfirm: () => dispatch(onActivationConfirmAction(ownProps)),
});

export default compose(
  withReducer(remoteAccessDialogReducerKey, remoteAccessDialogReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(RemoteAccessDialog);
